<template>
  <q-dialog
    :model-value="modelValue"
    persistent
    @update:model-value="emit('update:modelValue', $event)"
  >
    <q-card style="min-width: 500px">
      <q-card-section class="row items-center q-pb-none">
        <div class="text-h6">Set Switchboard Classification</div>
        <q-space />
        <q-btn v-close-popup icon="close" flat round dense />
      </q-card-section>

      <q-form @submit="onSubmit">
        <q-card-section>
          <q-select
            :model-value="formData.classification"
            label="Classification *"
            filled
            :options="[
              { label: 'Essential', value: 'essential' },
              { label: 'Non-Essential', value: 'non-essential' }
            ]"
            emit-value
            map-options
            :rules="[val => !!val || 'Classification is required']"
            class="q-mb-md"
            @update:model-value="emit('update:classification', $event)"
          >
            <template #prepend>
              <q-icon name="label" />
            </template>
          </q-select>

          <q-banner class="bg-info text-white rounded-borders">
            <template #avatar>
              <q-icon name="info" color="white" />
            </template>
            <strong>Essential</strong> switchboards power critical building systems that must remain operational during emergencies.
          </q-banner>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn v-close-popup flat label="Cancel" color="grey" />
          <q-btn unelevated label="Save" type="submit" color="primary" :loading="saving" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script setup>
  const props = defineProps({
    modelValue: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits([
    'update:modelValue',
    'update:classification',
    'submit',
  ]);

  function onSubmit() {
    emit('submit');
  }
</script>
